import { render, staticRenderFns } from "./IncidentsQuantity.vue?vue&type=template&id=66154e83"
import script from "./IncidentsQuantity.vue?vue&type=script&lang=js"
export * from "./IncidentsQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports